import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { EscrowContractAddress } from "../Services/EscrowContractAddress";
import EscrowContractAbi from "../Services/EscrowContractAbi.json";
import BEPContractAbi from "../Services/BEPContractAbi.json";
import { BEPContractAddress } from "../Services/BEPContractAddress";
import { EthContracatAddress } from "../Services/EthContractAddress";
import EthContractAbi from "../Services/EthContracatAbi.json";
import ETContractAbi from "../Services/ETContractAbi.json";
import { Spinner } from "flowbite-react";
import { useSigner, useNetwork } from "wagmi";
import React from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const { BigNumber } = require("ethers");

const SendDio = () => {
  const { chain } = useNetwork();
  //-------------------------------TOKEN CONTRACT ADDRESS----------------------------------//
  useEffect(() => {
    // console.log("useEffect", chain.id);
  }, [chain]);

  //---------------------------Use-States---------------------------------//
  const { data: signer } = useSigner();

  let [isOpen, setIsOpen] = useState(false);
  let [waiting, setWaiting] = useState(true);
  const [reciveraddress, setReciverAddress] = useState();
  const [amount, setAmount] = useState();

  const [dateTime, setDateTime] = useState();

  const [futureDate, setFutureDate] = useState(); //

  const navigate = useNavigate();

  
  //const history = useHistory();

  //-------------------------useEffect----------------------------------//

  //--------toogle DATE TIME MODAL---------------------//
  const DateModal = () => {
    setIsOpen(!isOpen);
  };
  let unixTimestamp;
  let timeMfive;

  //------------------HANDLE DATE AND TIME CHANGE USING MOMENTUM------------------------//
  function handleDateTimeChange(event) {
    setDateTime(event.target.value);
    //console.log("in milli seconds", dateTime);
    const bb = new Date(dateTime).getTime();
    // console.log("Time in seconds i hguess",bb)
    unixTimestamp = Math.floor(new Date(dateTime).getTime() / 1000);
    // console.log("Unix Time Stamp", unixTimestamp);

    timeMfive = unixTimestamp - 18000;
    setFutureDate(timeMfive);
    // console.log("future timestamp" + timeMfive);
  }

  //---------------------------nf-----------------------------------------------//
  const feeinPerc = (num, weii) => {
    const fee = num / 10;
    console.log("free in per", fee);
    const All = (fee * weii) / 100;
    console.log("allownace boy", All);
    return All;
  };

  //--------------------------CREATING ESCROW CONTRACT ADDRESS---------------------//
  const createEscrowContract = async () => {
    // console.log("account form chain id ", chain.id);

    if (chain.id === 11155111) {
      if (reciveraddress && amount && signer) {
        setWaiting(false);

        const BEPContract = new ethers.Contract(
          "0x776820f1a6adbED4B790EA58a01Af2d5F7E02967",
          ETContractAbi,
          signer
        );

        const wei = ethers.utils.parseEther(amount.toString());

        const amountInWei = parseInt(wei.toString());
        const amountInEther = ethers.utils.formatEther(amountInWei.toString());
        console.log("etherssss",amountInEther)
        // const amountInFloat = parseFloat(amountInEther);
        console.log("weiii", amountInWei);
        setWaiting(false);

        // const address = await signer.getAddress();
        console.log("todays address", reciveraddress);
        const address = signer.getAddress();
        BEPContract?.balanceOf(address).then(async(_blnce)=>{
          const bigNumber = BigNumber.from(_blnce._hex);
          const dioBalance = bigNumber.toString(); // time in seconds from the contract
          const dioInEth =  ethers.utils.formatEther(dioBalance)
          const dioFloat = parseFloat(dioInEth);
          console.log("Diottt",dioFloat);
          console.log("amoinuunt in float",);
          console.log("check",amount>dioFloat)
          if(amount>dioFloat){
            toast.error("Insufficeint Dio");
            setWaiting(true);

          }else{
            BEPContract?.transfer(reciveraddress, amountInWei.toString()).then(
              async (res) => {
                toast("Please wait token are being sent");
                res.wait().then(() => {
                  navigate("/sent");
                });
              }
            ); 

          }
        })

       
      } else {
        toast.error("Please fill all data");
      }
    } else {
      console.log("BEPPPPPP");
      if (reciveraddress && amount && signer) {
        setWaiting(false);

        const BEPContract = new ethers.Contract(
          BEPContractAddress,
          BEPContractAbi,
          signer
        );

        const wei = ethers.utils.parseEther(amount.toString());

        const amountInWei = parseInt(wei.toString());
        
        const amountInEther = ethers.utils.formatEther(amountInWei.toString());
        console.log("etherssss",amountInEther)
        console.log("weiii", amountInWei);
        
        
        // const address = await signer.getAddress();
        console.log("todays address", reciveraddress);
        const address = await signer.getAddress();

        BEPContract?.balanceOf(address).then(async(_blnce)=>{
          const bigNumber = BigNumber.from(_blnce._hex);
          const dioBalance = bigNumber.toString(); // time in seconds from the contract
          const dioInEth =  ethers.utils.formatEther(dioBalance)
          const dioFloat = parseFloat(dioInEth);
          console.log("Diottt",dioFloat);
          console.log("amoinuunt in float",);
          console.log("check",amount>dioFloat)
          if(amount>dioFloat ){
            toast.error("Insufficeint Dio");
             setWaiting(true);
          }else{
            BEPContract?.transfer(reciveraddress, amountInWei.toString()).then(
              async (res) => {
                toast("Please wait token are being sent");
                res.wait().then(() => {
                  navigate("/sent");
                });
              }
            );

          }

        })

      
      } else {
        toast.error("Please fill all data");
      }
    }
  };

  //---------------testing---------------//
  const test = () => {
    setWaiting(false);
  };

  return (
    <div className="h-screen flex items-center justify-center ">
      {waiting ? (
        <div className="bg-slate-100  p-20 h-fit shadow-md  ">
          <h1
            className="text-center text-3xl text-slate-600 font-semibold"
            onClick={test}
          >
            Send Dio
          </h1>
          <h1 className="mt-4 text-slate-600">Address</h1>
          <div class=" py-2 md:py-0">
            <label for="UserEmail" class="sr-only"></label>

            <input
              type="email"
              id="Recipient"
              placeholder=" Enter receiver address"
              class="w-full rounded-lg border border-gray-600 pr-10 shadow-sm sm:text-sm py-2 px-2 "
              onChange={(e) => setReciverAddress(e.target.value)}
            />

            <span class="pointer-events-none absolute inset-y-0 right-0 grid w-10 place-content-center text-gray-500"></span>
          </div>

          <h1 className=" text-slate-600">Amount</h1>
          <div className=" items-center gap-4">
            <div class=" py-2 md:py-0">
              <label for="UserEmail" class="sr-only"></label>

              <input
                type="email"
                id="Recipient"
                placeholder=" Input Here"
                class="w-full rounded-lg border border-gray-600 pr-10 shadow-sm sm:text-sm py-2 px-2 "
                onChange={(e) => setAmount(e.target.value)}
              />

              <span class="pointer-events-none absolute inset-y-0 right-0 grid w-10 place-content-center text-gray-500"></span>
            </div>
          </div>

          <div className="md:flex flex flex-row items-center gap-4  mt-8">
            <NavLink to={"/"}>
              <button className=" border rounded-full py-2 px-8 mt-2  md:mt-0 bg-slate-200 hover:bg-slate-400 w-fit text-md ">
                {" "}
                Cancel
              </button>
            </NavLink>{" "}
            <button
              className=" border rounded-full py-2 px-8 mt-2   md:mt-0 bg-slate-200 hover:bg-slate-400 w-fit text-md"
              onClick={createEscrowContract}
            >
              {" "}
              Send
            </button>
          </div>
        </div>
      ) : (
        <Spinner />
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};

export default SendDio;
